class TrSlider extends HTMLElement {
	selectors = {
		slide: '[data-tr-js-slider-slide]',
		heroVideo: '[data-tr-js-hero-video]',
		heroSource: '[data-tr-js-hero-source]'
	};

	attributes = {
		config: 'data-tr-js-slider-config',
		legacyConfig: 'data-config'
	};

	stateClasses = {};

	config = {};

	slider = null;

	connectedCallback() {
		this.slideElements = [...this.querySelectorAll(this.selectors.slide)];
		this.heroVideoElements = [
			...this.querySelectorAll(this.selectors.heroVideo)
		];
		this.mobileMediaQuery = window.matchMedia('(max-width: 989px)');

		this.init();
		this.loadHeroVideos();

		document.addEventListener('shopify:section:load', this.onSectionLoad);
		document.addEventListener('shopify:block:select', this.onBlockSelect);
		this.mobileMediaQuery.addEventListener('change', this.onViewportChange);
	}

	disconnectedCallback() {
		document.removeEventListener('shopify:section:load', this.onSectionLoad);
		document.removeEventListener('shopify:block:select', this.onBlockSelect);
		this.mobileMediaQuery.removeEventListener('change', this.onViewportChange);

		this.destroy();
	}

	init() {
		this.destroy();
		this.getConfig();

		if (typeof Swiper === 'undefined') return;

		this.slider = new Swiper(this, this.config);
	}

	onSectionLoad = event => {
		if (
			!this.closest(`#${event.detail.sectionId}`) &&
			!this.closest(`#shopify-section-${event.detail.sectionId}`)
		)
			return;

		this.init();
		this.loadHeroVideos();
	};

	onViewportChange = () => {
		this.loadHeroVideos();
	};

	onBlockSelect = event => {
		if (!this.slider) return;

		const selectedSlideIndex = this.slideElements.findIndex(
			slideElement =>
				slideElement.dataset.trJsSliderSlide === event.detail.blockId
		);

		if (selectedSlideIndex === -1) return;

		if (this.slider.params.loop) {
			this.slider.slideToLoop(selectedSlideIndex);
			return;
		}

		this.slider.slideTo(selectedSlideIndex);
	};

	getConfig() {
		try {
			const config =
				this.getAttribute(this.attributes.config) ||
				this.getAttribute(this.attributes.legacyConfig);

			this.config = JSON.parse(config) || {};
		} catch (error) {
			console.error('Error parsing JSON:', error);
			this.config = {};
		}
	}

	loadHeroVideos() {
		if (!this.heroVideoElements.length) return;

		const activeVideoType = this.mobileMediaQuery.matches
			? 'mobile'
			: 'desktop';
		const hasActiveVideo = this.heroVideoElements.some(
			videoElement =>
				videoElement.dataset.trJsHeroVideo === activeVideoType
		);

		this.heroVideoElements.forEach(videoElement => {
			const shouldLoad = hasActiveVideo
				? videoElement.dataset.trJsHeroVideo === activeVideoType
				: true;
			const sourceElements = [
				...videoElement.querySelectorAll(this.selectors.heroSource)
			];
			const isLoaded = sourceElements.some(sourceElement =>
				sourceElement.hasAttribute('src')
			);

			if (!sourceElements.length) return;

			if (shouldLoad && !isLoaded) {
				sourceElements.forEach(sourceElement => {
					sourceElement.src = sourceElement.dataset.trJsHeroSource;
				});
				videoElement.load();
				videoElement.play().catch(() => {});
			}

			if (!shouldLoad && isLoaded) {
				videoElement.pause();
				sourceElements.forEach(sourceElement => {
					sourceElement.removeAttribute('src');
				});
				videoElement.load();
			}
		});
	}

	destroy() {
		if (!this.slider) return;

		this.slider.destroy();

		this.slider = null;
	}
}

if (!customElements.get('tr-slider')) {
	customElements.define('tr-slider', TrSlider);
}
